


import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { getRegularDriverVehicles } from "../../features/driversVehicles/driversVehiclesSlice"
import RegularVehicleItem from "./RegularVehicleItem"
import InputSelect from "../shared/input/new/InputSelect"
import Btn from "../shared/button/Btn"
import { showModal } from "../../features/modal/modalSlice"

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;


    .top-container{

        margin-bottom: 20px;
        display: flex;
        justify-content: flex-end;

    }

    .list{
        display: flex;
        flex-direction: column;
        gap: 10px;
        height: 500px;
        max-height: 500px;
        overflow: auto;
    }

    .btn-container{
        width: 100%;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

`

const vehicleTypes = [
    {
        id: 1,
        text: "Hepsi"
    },
    {
        id: 2,
        text: "Çekici"
    },
    {
        id: 1,
        text: "Römork"
    },
]

const RegularDriverItemVehicles = ({uyeItemData}) => {

    const dispatch = useDispatch()

    const [vehicleType, setVehicleType] = useState({
        id: 1,
        text: "Hepsi"
    })

    const [openedVehicleDocs, setOpenedVehicleDocs] = useState(null)

    const {regularDriverVehicles} = useSelector(state => state.driversVehicles)

    
    useEffect(() => {
        dispatch(getRegularDriverVehicles(uyeItemData.phoneNumber))
    },[])

  return (
    <Container>
        <div className="top-container">
            {/* <InputSelect data={vehicleType.text} setData={setVehicleType} initialOptions={vehicleTypes} labelText={"Araç Tipi"} inputWidth={"220px"} name={"vehicleType"}/> */}
        </div>

        <div className="list">
            {
                regularDriverVehicles.map(item => (
                    <RegularVehicleItem item={item} openedVehicleDocs={openedVehicleDocs} setOpenedVehicleDocs={setOpenedVehicleDocs}/>
                ))
            }

        </div>
         <div className="btn-container">
            <Btn handleClick={() => dispatch(showModal(null))} width={"220px"} bgColor="transparent" borderColor="#E85446" color="#E85446" padding="10px">Kapat</Btn>
        </div>
    </Container>
  )
}

export default RegularDriverItemVehicles